if (!customElements.get("custom-video")) {
    class customVideo extends HTMLElement {
        constructor() {
            super();
            this.videoWrapper = this.querySelector('.td-video-wrapper');
            this.video = this.querySelector('video');
            this.playbutton = this.querySelector('.video-play-button');
            this.playing = false
        }

        connectedCallback() {
            if (this.video && this.playbutton && this.videoWrapper) {
                this.videoWrapper.addEventListener('click', () => {
                    if (this.playing) {
                        this.playbutton.style.display = "block";
                        this.video.pause();
                        this.playing = false;
                    } else {
                        this.playbutton.style.display = "none";
                        this.video.play().catch(e => console.error('Error attempting to play video:', e));
                        this.playing = true;
                    }
                })
            }
        }
    }

    customElements.define("custom-video", customVideo);
}